import React from 'react'
import { keycloak } from './lib'
import { App } from './App'
import './styles.css'
import { createRoot } from 'react-dom/client'

const container = document.getElementById('root') as HTMLDivElement
const root = createRoot(container)

const Index = () => (
  <React.StrictMode>
    <App />
  </React.StrictMode>
)

keycloak.init({ onLoad: 'login-required', pkceMethod: 'S256' }).then(() => {
  root.render(<Index />)
})
